exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Compliance.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":{"safe":true,"reduceIdents":false,"zindex":false,"mergeRules":false,"discardComments":{"removeAll":true}},"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09b19c5d","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Compliance.vue
// module id = 870
// module chunks = 14